import React, { Component } from "react";
import { Form, Button } from "react-bootstrap";
import $ from "jquery";

export default class FormInformatica extends Component {
  constructor(props) {
    super(props);

    this.InformaticaPost = this.InformaticaPost.bind(this);
    this.InformaticaPut = this.InformaticaPut.bind(this);
    this.getDefaultValue = this.getDefaultValue.bind(this);
  }

  InformaticaPost(event) {
    event.preventDefault();
    let $this = $(this);

    let settings = {
      url: process.env.REACT_APP_API_URL + "/usuarios/" + $this[0].props.DatosUsuario.id + "/informatica",
      method: "POST",
      timeout: 0,
      xhrFields: {
        withCredentials: true,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      data: {
        programName: event.target["programName"].value,
        level: event.target["level"].value,
      },
    };

    $.ajax(settings)
      .done(function (response) {
        $this[0].props.setAlert("", "Se han añadido los datos correctamente", "success");
        $this[0].props.setInformatica(response);
      })
      .fail($this[0].props.ErrorHandling);
  }

  InformaticaPut(event) {
    event.preventDefault();
    let $this = $(this);
    let settings = {
      url: process.env.REACT_APP_API_URL + "/usuarios/" + $this[0].props.DatosUsuario.id + "/informatica/" + $this[0].props.DatosUsuario.datosInformatica[this.props.id].id,
      method: "PUT",
      timeout: 0,
      xhrFields: {
        withCredentials: true,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      data: {
        programName: event.target["programName"].value,
        level: event.target["level"].value,
      },
    };

    $.ajax(settings)
      .done(function (response) {
        $this[0].props.setAlert("", "Se han editado los datos correctamente", "success");
        $this[0].props.putInformatica(response, $this[0].props.id);
      })
      .fail($this[0].props.ErrorHandling);
  }

  getDefaultValue(field) {
    let defaultvalue = null;
    if (this.props.id !== undefined) {
      defaultvalue = this.props.DatosUsuario.datosInformatica[this.props.id][field];
    }
    return defaultvalue;
  }

  render() {
    return (
      <Form className=" p-4" onSubmit={this.props.id !== undefined ? this.InformaticaPut : this.InformaticaPost} autoComplete="off">
        <Form.Group>
          <Form.Row>
            <small className="mb-3">
              Los campos con un <b>*</b> deben de ser rellenados.
            </small>
          </Form.Row>
          <Form.Label>Nombre del Programa/Lenguaje de Programación *</Form.Label>
          <Form.Control required autoComplete="nope" maxLength="100" type="text" name="programName" defaultValue={this.getDefaultValue("programName")} />
        </Form.Group>
        <Form.Group>
          <Form.Label>Nivel *</Form.Label>
          <Form.Control required autoComplete="nope" as="select" name="level" defaultValue={this.getDefaultValue("level")}>
            <option>Básico</option>
            <option>Intermedio</option>
            <option>Avanzado</option>
            <option>Especializado</option>
          </Form.Control>
        </Form.Group>

        <Form.Group>
          <Button
            type="submit"
            variant="outline-success"
            className="btn btn-block mt-5"
            //onClick={this.props.handleButtonShow} TODO cuando se le da a guardar no se cierra el modal
            name="Cerrar"
          >
            Guardar
          </Button>
        </Form.Group>
      </Form>
    );
  }
}
